
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { Meta, MetaInfo } from '@/decorators';

	// Static import for faster rendering
	import { AppFooter, AppHeader } from '@/components/layout';
	import { PagePermissionEnum } from '@/types/enum/PermissionEnum';
	import { mdiClose } from '@mdi/js';
	import eventBus from '@/services/Event/EventBus';
	import CustomNotificationBar from '@/components/CustomNotificationBar.vue';

	/** App is the main component */
	@Component({
		components: {
			AppHeader,
			AppFooter,
			CustomNotificationBar
		},
		watch: {
			$route: {
				handler() {
					(this as any).refreshLoginState();
				}
			}
		}
	})
	export default class App extends Vue {
		messageSystem = '' as string;
		closeIcon = mdiClose;
		isLogged = false;

		get hasNavigation(): boolean {
			return this.$can(PagePermissionEnum.CONNECTED) &&
				(!this.$route.meta || (this.$route.meta && !this.$route.meta.disableNavigation));
		}

		get hasHeader(): boolean {
			return (!this.$route.meta || (this.$route.meta && !this.$route.meta.hideHeader));
		}

		get hasFooter(): boolean {
			return (!this.$route.meta || (this.$route.meta && !this.$route.meta.hideFooter));
		}

		get displayMessageSystem(): boolean {
			return '' !== this.messageSystem.toString();
		}

		set displayMessageSystem(value: boolean) {
			this.$emit('change-message-system', value);
		}

		refreshLoginState(): void {
			this.isLogged = this.hasNavigation;
		}

		created() {
			if ('true' === window.WS_CONNECTION_ENABLED) {
				const conn = new WebSocket(window.WS_SERVER_HOST);

				conn.onmessage = event => {
					const data = JSON.parse(event.data);

					if ('event-notification' === data.type) {
						const notification = this.$t(`components.globals.webSocketNotification.${data.message}`) as string;
						this.messageSystem = notification.includes('components.globals') ? data.message : notification;
					}

					if ('resource-id-callback' === data.type) {
						localStorage.setItem('resource-id-callback', data.message);
					}

					if ('event-export-status-updated' === data.type) {
						eventBus.$emit('event-export-status-updated');
					}
				};
			}
		}

		/** The meta informations of the route */
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				// If no subcomponents specify a metaInfo.title, this title will be used
				title: this.$t('common.meta.title') as string,
				// All titles will be injected into this template
				titleTemplate: this.$t('common.meta.titleTemplate') as string,
				meta: [
					{
						name: 'description',
						content: this.$t('common.meta.description') as string
					}
				]
			};
		}
	}
